import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/hero/hero_1_title_2.png")